module.exports = __webpack_public_path__ + "img/service3.ccbf1387.jpg";